import { YoApi } from '@yooink/yorestapi/frontend/es/YoApi';

class ProductsApi extends YoApi {
	async getUnits ({ filter }) {
		return this.simpleRequest('get', 'units', {
			params: filter
		});
	}

	async createLinks (baseId, targetId, oarams) {
		return this.simpleRequest('put', 'links', {
			base: baseId,
			target: targetId,
			...oarams
		});
	}

	async unlink (id) {
		return this.simpleRequest('delete', 'links', {
			params: { id }
		});
	}

	async getLinks (id) {
		return this.simpleRequest('get', 'links', 'for', id, {});
	}

	async clone (id, { link }) {
		return this.simpleRequest('put', id, 'clone', { link });
	}

	async createInMS (id) {
		return this.simpleRequest('post', id, 'integrations', 'moysklad', 'create', {});
	}

	async syncMSState (id) {
		return this.simpleRequest('post', id, 'integrations', 'moysklad', 'sync', {});
	}

	async createInAmoCrm (id) {
		return this.simpleRequest('post', id, 'integrations', 'amocrm', 'create', {});
	}

	async getReviews (id) {
		return this.simpleRequest('get', id, 'reviews', {});
	}

	async approveReview (productId, reviewId) {
		return this.simpleRequest('post', productId, 'reviews', reviewId, 'approve', {});
	}

	async blockReview (productId, reviewId) {
		return this.simpleRequest('post', productId, 'reviews', reviewId, 'block', {});
	}

	async setVisibleReview (productId, reviewId, isVisible) {
		return this.simpleRequest('post', productId, 'reviews', reviewId, 'setVisible', { isVisible });
	}

	async sendReviewResponse (productId, reviewId, message) {
		return this.simpleRequest('post', productId, 'reviews', reviewId, 'sendResponse', { message });
	}

	async saveSortOrder (categoryId, orders) {
		return this.simpleRequest('post', 'changeOrders', { categoryId, orders });
	}
}

export default new ProductsApi({
	apiVersion: 'v2',
	endPoint: 'products'
});

export function getProductsApi (id) {
	return new ProductsApi({
		apiVersion: 'v2',
        endPoint: 'products',
		itemId: id
	});
}
